import { Document, Font, Image, Page, StyleSheet, Text, View } from '@react-pdf/renderer';
import moment from 'moment';
import Tw_Cen_MT_Negrita from '../../../../componentes/font/Tw_Cen_MT/TCB_____.TTF';
import Tw_Cen_MT from '../../../../componentes/font/Tw_Cen_MT/TCM_____.TTF';
import NumeroALetras from '../../../../componentes/funciones/NumeroALetras';
import { NegocioConfig } from "../../../../configuracion/Empresa";
import { formatoMoneda, formatoNumero } from "../../../../configuracion/validaciones";

Font.register({ family: 'Tw_Cen_MT', src: Tw_Cen_MT });
Font.register({ family: 'Tw_Cen_MT_Negrita', src: Tw_Cen_MT_Negrita });

const styles = StyleSheet.create({
    page: {
        fontFamily: 'Tw_Cen_MT',
        fontSize: 10,
        paddingTop: 40,
        paddingBottom: 50,
        paddingHorizontal: 60,
        backgroundColor: '#ffffff',
    },
    header: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        marginBottom: 5,
        paddingBottom: 0,
    },
    companyInfoLeft: {
        flexGrow: 1,
        textAlign: 'left',
    },
    companyName: {
        fontFamily: 'Tw_Cen_MT_Negrita',
        fontSize: 16,
        color: '#333',
        marginBottom: 3,
    },
    companyAddress: {
        fontSize: 9,
        color: '#666',
        marginBottom: 2,
    },
    logoContainer: {
        width: 100,
        height: 100,
        marginLeft: 20,
        marginTop: -10
    },
    logo: {
        width: 100,
        height: 100,
        objectFit: 'cover',
        alignSelf: 'center',
        marginBottom: 2,
        borderRadius: 15,
        overflow: 'hidden',
    },
    title: {
        fontSize: 16,
        fontFamily: 'Tw_Cen_MT_Negrita',
        color: '#222',
        letterSpacing: 1,
        textTransform: 'uppercase',
        marginTop: 15,
    },
    infoGrid: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginBottom: 5,
        marginTop: 5,
    },
    infoColumn: {
        width: '33%',
    },
    infoLabel: {
        fontFamily: 'Tw_Cen_MT_Negrita',
        fontSize: 10,
        color: '#444',
        marginBottom: 3,
    },
    infoText: {
        fontSize: 10,
        marginBottom: 7,
        color: '#666',
    },
    sectionTitle: {
        fontFamily: 'Tw_Cen_MT_Negrita',
        fontSize: 12,
        marginBottom: 10,
        paddingBottom: 3,
        borderBottomWidth: 1.5,
        borderBottomColor: '#D0D0D0',
        color: '#333',
        textTransform: 'uppercase',
    },
    table: {
        width: '100%',
        marginBottom: 10,
    },
    tableHeader: {
        flexDirection: 'row',
        backgroundColor: '#F5F5F5',
        borderBottomWidth: 1,
        borderBottomColor: '#E0E0E0',
        paddingVertical: 8,
        fontFamily: 'Tw_Cen_MT_Negrita',
        fontSize: 10,
        color: '#333',
    },
    tableRow: {
        flexDirection: 'row',
        borderBottomWidth: 0.5,
        borderBottomColor: '#F0F0F0',
        paddingVertical: 6,
    },
    colDescription: { width: '45%', paddingLeft: 5 },
    colQty: { width: '15%', textAlign: 'center' },
    colPrice: { width: '20%', textAlign: 'right', paddingRight: 5 },
    colTotal: { width: '20%', textAlign: 'right', paddingRight: 5 },
    itemText: { fontSize: 10, color: '#555' },

    totalsWrapper: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        marginTop: 10,
    },
    totalsContainer: {
        width: '40%',
        borderTopWidth: 1.5,
        borderTopColor: '#E0E0E0',
        paddingTop: 10,
    },
    leftColumn: {
        textAlign: 'left',
        width: '50%',
        paddingTop: 5,
    },
    totalUnderWords: {
        fontSize: 12,
        fontFamily: 'Tw_Cen_MT_Negrita',
        marginBottom: 20,
    },
    totalsRow: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginBottom: 4,
    },
    totalLabel: { fontSize: 10, color: '#555' },
    totalValue: { fontSize: 10, fontFamily: 'Tw_Cen_MT_Negrita', color: '#333' },

    grandTotalRow: {
        marginTop: 8,
        paddingTop: 8,
        borderTopWidth: 1,
        borderTopColor: '#D0D0D0',
        flexDirection: 'row',
        justifyContent: 'space-between',
    },
    grandTotalLabel: { fontFamily: 'Tw_Cen_MT_Negrita', fontSize: 13, color: '#000' },
    grandTotalValue: { fontFamily: 'Tw_Cen_MT_Negrita', fontSize: 13, color: '#000' },

    amountInWords: {
        fontSize: 9,
        fontFamily: 'Tw_Cen_MT_Negrita',
        textTransform: 'uppercase',
        marginBottom: 5,
    },
    paymentDetails: {
        marginTop: 10,
        paddingTop: 10,
        borderTopWidth: 1,
        borderTopColor: '#F0F0F0',
    },
    separador: {
        borderTopWidth: 1,
        borderTopColor: '#F0F0F0',
    },
    footer: {
        position: 'absolute',
        bottom: 30,
        left: 0,
        right: 0,
        textAlign: 'center',
        fontSize: 8,
        color: '#888',
        paddingHorizontal: 60,
    },
    caiInfo: {
        marginTop: 10,
        fontSize: 8,
        textAlign: 'center',
        lineHeight: 1.4,
        color: '#666',
    },
    certificadosCol: {
        width: '45%',
    },
    certificadosColRight: {
        width: '45%',
        paddingLeft: 15,
        borderLeftWidth: 1,
        borderLeftColor: '#F0F0F0',
    },
    infoColumnHalf: {
        width: '80%', // Nueva clase para cuando solo hay Nombre y RTN
    },
});

const ReporteVentas = ({ venta }) => {
    if (!venta) {
        return <Document><Page size="LETTER" style={styles.page}><Text>No hay datos de venta para mostrar.</Text></Page></Document>;
    }

    const {
        fechaCreacion, Cliente, Empleado, ventadetallepedidos = [], ventadetallecita = [],
        descuento = 0, exento = 0, exonerado = 0, importeImpuesto15 = 0, importeImpuesto18 = 0,
        impuesto15 = 0, impuesto18 = 0, totalVenta = 0, subtotal = 0, pagoVenta = [],
        rtn, facturas = [], recibos = [], createdAt
    } = venta;
    
    const items = [...ventadetallepedidos, ...ventadetallecita];
    const clienteNombreCompleto = Cliente?.nombreCorto || 'Consumidor Final';
    const empresaNombre = Cliente?.ClienteEmpresas?.[0]?.nombre;
    const empresaRtn = Cliente?.ClienteEmpresas?.[0]?.rtn;

    const rtnAImprimir = rtn || Cliente?.rtn || empresaRtn || "";
    let nombreAImprimir = clienteNombreCompleto;
    if (rtnAImprimir && rtnAImprimir === empresaRtn && empresaNombre && empresaNombre !== "") {
        nombreAImprimir = empresaNombre;
    }
    
    const pagosCompletados = pagoVenta?.map(pv => pv.pago).filter(p => p && p.estado !== 'Anulada') || [];
    const pago = pagosCompletados[pagosCompletados.length - 1] || {};
    const recibido = parseFloat(pago.recibido || 0);
    const cambio = Math.max(recibido - parseFloat(totalVenta), 0);
    const efectivoPagado = pago.pagoefectivos?.reduce((sum, p) => sum + parseFloat(p.monto || 0), 0) || 0;
    const transferenciaPagado = pago.pagotransferencia?.reduce((sum, p) => sum + parseFloat(p.monto || 0), 0) || 0;
    const tarjetaPagado = pago.pagotarjeta?.reduce((sum, p) => sum + parseFloat(p.monto || 0), 0) || 0;

    const esCreditoDoc = venta?.tipoVenta === 'Credito' || venta?.tipoVenta === 'Crédito' || (Array.isArray(venta?.creditos) && venta?.creditos.length > 0) || venta?.creditoId != null;
    const creditoObj = Array.isArray(venta?.creditos) && venta?.creditos.length > 0 ? venta.creditos[0] : {};
    const anticipoDoc = parseFloat(venta?.anticipo ?? creditoObj?.anticipo ?? (esCreditoDoc ? recibido : 0));
    const saldoCreditoDoc = parseFloat(venta?.saldoCredito ?? creditoObj?.saldo ?? (esCreditoDoc ? Math.max(parseFloat(totalVenta || 0) - anticipoDoc, 0) : 0));
    const fechaVencimientoCredito = venta?.fechaVencimiento || creditoObj?.fechaVencimiento;

    const isFacturaDoc = facturas.length > 0;
    const isReciboDoc = recibos.length > 0;
    const factura = Array.isArray(facturas) && facturas.length > 0 ? facturas[0] : null;
    const facturacai = factura?.facturacai ?? null;
    const facturaNumero = factura?.numeroFactura ?? venta.numeroFactura ?? 0;
    const CAI = facturacai?.CAI ?? null;

    const recibo = Array.isArray(recibos) && recibos.length > 0 ? recibos[0] : null;

    const reciboNumero = recibo?.id ?? 0;
    
    const fechaLimiteFormateada = facturacai?.fechaLimite && moment(facturacai.fechaLimite).isValid()
        ? moment(facturacai.fechaLimite).format("DD/MM/YYYY") : null;

    const numeroDocumento = isFacturaDoc
        ? "000-002-01-" + formatoNumero(facturaNumero)
        : isReciboDoc ?
            String(reciboNumero || "—") :
            "—";

    const numeroInicio = isFacturaDoc
        ? "000-002-01-" + formatoNumero(facturacai.numeroInicial)
        : String(venta?.id || "—");

    const numeroFin = isFacturaDoc
        ? "000-002-01-" + formatoNumero(facturacai.numeroFinal)
        : String(venta?.id || "—");

    const tipoDocumento = isFacturaDoc ? "FACTURA" : "RECIBO";

    const constanciaExonerado = facturas[0]?.facturaconstancia[0]?.numeroConstancia || null;
    const ordenCompraExenta = facturas[0]?.facturaexentos[0]?.numeroOrden || null;
    const registroSag = facturas[0]?.facturasags[0]?.numeroRegistro || null;

    const itemsReporte = items.map((item) => {
        const cantidad = parseFloat(item.cantidad || 0);
        const precioUnitarioVenta = isFacturaDoc? parseFloat(item.precioSinImpuesto || 0) : parseFloat(item.precio || 0);
        const precioOriginal = parseFloat(item.precioOriginal || precioUnitarioVenta);
        const descuentoItem = parseFloat(item.descuento || 0);
        const subtotalMostrado = isFacturaDoc? parseFloat(item.subtotalSinImpuesto || 0): parseFloat(item.subtotal || 0);
        return {
            descripcion: item.producto?.nombre || item.servicio?.nombre || 'N/A',
            cantidad,
            precioUnitarioMostrado: precioUnitarioVenta,
            subtotalItemMostrado: subtotalMostrado,
            precioOriginal,
            descuentoItem,
            mostrarDescuento: descuentoItem > 0 && precioOriginal > precioUnitarioVenta,
        };
    });

    return (
        <Document>
            <Page size="LETTER" style={styles.page}>
                <View style={styles.header} fixed>
                    <View style={styles.companyInfoLeft}>
                        <Text style={styles.companyName}>{NegocioConfig.nombre}</Text>
                        <Text style={styles.companyAddress}>{NegocioConfig.direccion}</Text>
                        <Text style={styles.companyAddress}>RTN: {NegocioConfig.rtn} Email: {NegocioConfig.correo}</Text>
                        <Text style={styles.companyAddress}>Tel: {NegocioConfig.telefono}</Text>
                        <Text style={styles.title}>{tipoDocumento} N° {numeroDocumento}</Text>
                        {isFacturaDoc && CAI &&
                            <>
                                <Text style={[styles.companyAddress]}>CAI: {CAI} Fecha Límite de Emisión: {fechaLimiteFormateada}</Text>
                                <Text style={[styles.companyAddress]}>Rango Autorizado: {numeroInicio} al {numeroFin}</Text>
                            </>
                        }
                    </View>
                    {NegocioConfig.logo && (
                        <View style={styles.logoContainer}>
                            <Image style={styles.logo} src={NegocioConfig.logo} />
                        </View>
                    )}
                </View>

                <View style={styles.infoGrid}>
                    <View style={styles.infoColumn}>
                        <Text style={styles.infoLabel}>Fecha:</Text>
                        <Text style={styles.infoText}>{moment(createdAt).format('DD/MM/YYYY HH:mm')}</Text>
                    </View>
                    <View style={styles.infoColumn}>
                        <Text style={styles.infoLabel}>Atendido Por:</Text>
                        <Text style={styles.infoText}>{Empleado?.nombreCorto || '—'}</Text>
                    </View>
                    <View style={styles.infoColumn}>
                        <Text style={styles.infoLabel}>Estado:</Text>
                        <Text style={styles.infoText}>{venta.estado || 'Pagado'}</Text>
                    </View>
                    <View style={styles.infoColumn}>
                        <Text style={styles.infoLabel}>Nombre del Cliente:</Text>
                        <Text style={styles.infoText}>{nombreAImprimir}</Text>
                    </View>
                    <View style={styles.infoColumn}>
                        <Text style={styles.infoLabel}>RTN Cliente:</Text>
                        <Text style={styles.infoText}>{rtnAImprimir || 'N/A'}</Text>
                    </View>
                </View>

                <View style={styles.table} wrap={true}>
                    <View style={styles.tableHeader} fixed>
                        <Text style={styles.colDescription}>DESCRIPCIÓN</Text>
                        <Text style={styles.colQty}>CANT.</Text>
                        <Text style={styles.colPrice}>P. UNITARIO</Text>
                        <Text style={styles.colTotal}>SUBTOTAL</Text>
                    </View>
                    {itemsReporte.map((item, index) => (
                        <View key={index} style={styles.tableRow} wrap={false}>
                            <View style={styles.colDescription}>
                                <Text style={styles.itemText}>{item.descripcion}</Text>
                                {item.mostrarDescuento && (
                                    <Text style={{ fontSize: 7, color: 'red' }}>
                                        (DES: {formatoMoneda(item.precioOriginal)} - {formatoMoneda(item.descuentoItem)})
                                    </Text>
                                )}
                            </View>
                            <Text style={[styles.itemText, styles.colQty]}>{item.cantidad}</Text>
                            <Text style={[styles.itemText, styles.colPrice]}>{formatoMoneda(item.precioUnitarioMostrado)}</Text>
                            <Text style={[styles.itemText, styles.colTotal]}>{formatoMoneda(item.subtotalItemMostrado)}</Text>
                        </View>
                    ))}
                </View>

                <View style={styles.totalsWrapper}>
                    <View style={styles.leftColumn}>
                        {tipoDocumento === "FACTURA" && (
                            <View style={{ marginTop: 5 }}>
                                <Text style={{ fontSize: 10, color: '#444', marginBottom: 2 }}>
                                    Nª Correlativo de orden de compra exenta: {ordenCompraExenta || 'N/A'}
                                </Text>
                                <Text style={{ fontSize: 10, color: '#444', marginBottom: 2 }}>
                                    Nª Correlativo de constancia de registro exonerado: {constanciaExonerado || 'N/A'}
                                </Text>
                                <Text style={{ fontSize: 10, color: '#444' }}>
                                    Nª identificacion de regsitro de la SAG: {registroSag || 'N/A'}
                                </Text>
                            </View>
                        )}
                        {(pagosCompletados.length > 0 || esCreditoDoc) && (
                            <View style={styles.paymentDetails}>
                                <Text style={[styles.infoLabel, { marginBottom: 5 }]}>DETALLE DE PAGO</Text>
                                {esCreditoDoc && (
                                    <>
                                        <View style={styles.totalsRow}>
                                            <Text style={[styles.totalLabel, { color: '#0056b3', fontFamily: 'Tw_Cen_MT_Negrita' }]}>Modalidad:</Text>
                                            <Text style={[styles.totalValue, { color: '#0056b3' }]}>VENTA AL CRÉDITO</Text>
                                        </View>
                                        {anticipoDoc > 0 && (
                                            <View style={styles.totalsRow}>
                                                <Text style={[styles.totalLabel, { color: '#28a745', fontFamily: 'Tw_Cen_MT_Negrita' }]}>Anticipo / Prima:</Text>
                                                <Text style={[styles.totalValue, { color: '#28a745' }]}>{formatoMoneda(anticipoDoc)}</Text>
                                            </View>
                                        )}
                                        <View style={styles.totalsRow}>
                                            <Text style={[styles.totalLabel, { color: '#dc3545', fontFamily: 'Tw_Cen_MT_Negrita' }]}>Saldo Pendiente:</Text>
                                            <Text style={[styles.totalValue, { color: '#dc3545' }]}>{formatoMoneda(saldoCreditoDoc)}</Text>
                                        </View>
                                        {fechaVencimientoCredito && (
                                            <View style={styles.totalsRow}>
                                                <Text style={styles.totalLabel}>Vencimiento:</Text>
                                                <Text style={styles.totalValue}>{moment(fechaVencimientoCredito).format('DD/MM/YYYY')}</Text>
                                            </View>
                                        )}
                                        <hr style={styles.separador} />
                                    </>
                                )}
                                <View style={styles.totalsRow}>
                                    <Text style={styles.totalLabel}>Recibido:</Text>
                                    <Text style={styles.totalValue}>{formatoMoneda(recibido)}</Text>
                                </View>
                                {efectivoPagado > 0 &&
                                    <View style={styles.totalsRow}>
                                        <Text style={styles.totalLabel}>Efectivo:</Text>
                                        <Text style={styles.totalValue}>{formatoMoneda(efectivoPagado)}</Text>
                                    </View>
                                }
                                {tarjetaPagado > 0 &&
                                    <View style={styles.totalsRow}>
                                        <Text style={styles.totalLabel}>Tarjeta:</Text>
                                        <Text style={styles.totalValue}>{formatoMoneda(tarjetaPagado)}</Text>
                                    </View>
                                }
                                {transferenciaPagado > 0 &&
                                    <View style={styles.totalsRow}>
                                        <Text style={styles.totalLabel}>Transferencia:</Text>
                                        <Text style={styles.totalValue}>{formatoMoneda(transferenciaPagado)}</Text>
                                    </View>
                                }
                                <hr style={styles.separador} />
                                <View style={[styles.totalsRow, { marginTop: 3 }]}>
                                    <Text style={styles.totalLabel}>Cambio:</Text>
                                    <Text style={styles.totalValue}>{formatoMoneda(cambio)}</Text>
                                </View>
                            </View>
                        )}
                    </View>

                    <View style={styles.totalsContainer}>
                        <View style={styles.totalsRow}>
                            <Text style={styles.totalLabel}>Subtotal Ítems:</Text>
                            <Text style={styles.totalValue}>{formatoMoneda(subtotal)}</Text>
                        </View>
                        {parseFloat(descuento) > 0 && (
                            <View style={styles.totalsRow}>
                                <Text style={styles.totalLabel}>Descuento:</Text>
                                <Text style={styles.totalValue}>-{formatoMoneda(descuento)}</Text>
                            </View>
                        )}
                        {tipoDocumento === "FACTURA" ? (
                            <>
                                <View style={styles.totalsRow}>
                                    <Text style={styles.totalLabel}>Importe Exonerado:</Text>
                                    <Text style={styles.totalValue}>{formatoMoneda(exonerado)}</Text>
                                </View>
                                <View style={styles.totalsRow}>
                                    <Text style={styles.totalLabel}>Importe Exento:</Text>
                                    <Text style={styles.totalValue}>{formatoMoneda(exento)}</Text>
                                </View>
                                <View style={styles.totalsRow}>
                                    <Text style={styles.totalLabel}>Importe 15%:</Text>
                                    <Text style={styles.totalValue}>{formatoMoneda(importeImpuesto15)}</Text>
                                </View>
                                <View style={styles.totalsRow}>
                                    <Text style={styles.totalLabel}>Importe 18%:</Text>
                                    <Text style={styles.totalValue}>{formatoMoneda(importeImpuesto18)}</Text>
                                </View>
                                <View style={styles.totalsRow}>
                                    <Text style={styles.totalLabel}>ISV 15%:</Text>
                                    <Text style={styles.totalValue}>{formatoMoneda(impuesto15)}</Text>
                                </View>
                                <View style={styles.totalsRow}>
                                    <Text style={styles.totalLabel}>ISV 18%:</Text>
                                    <Text style={styles.totalValue}>{formatoMoneda(impuesto18)}</Text>
                                </View>
                                <View style={styles.grandTotalRow}>
                                    <Text style={styles.grandTotalLabel}>TOTAL A PAGAR:</Text>
                                    <Text style={styles.grandTotalValue}>{formatoMoneda(totalVenta)}</Text>
                                </View>
                            </>
                        ) : (
                            <View style={styles.grandTotalRow}>
                                <Text style={styles.grandTotalLabel}>TOTAL A PAGAR:</Text>
                                <Text style={styles.grandTotalValue}>{formatoMoneda(totalVenta)}</Text>
                            </View>
                        )}
                        <hr style={[styles.separador, { marginTop: 5 }]} />
                        <Text style={[styles.infoLabel, { marginTop: 3 }]}>VALOR EN LETRAS:</Text>
                        <Text style={styles.amountInWords}>
                            {NumeroALetras(totalVenta)}
                        </Text>
                    </View>
                </View>

                <View style={styles.footer} fixed>
                    <View style={styles.infoGrid}>
                        <View style={styles.infoColumn}>
                            <Text style={styles.infoLabel}>Original: Cliente</Text>
                        </View>
                        <View style={styles.infoColumn}>
                            <Text style={styles.infoLabel}>{tipoDocumento === 'FACTURA' ? "¡Gracias por su compra!" : "Gracias por su preferencia."}</Text>
                        </View>
                        <View style={styles.infoColumn}>
                            <Text style={styles.infoLabel}>Copia: Emisor</Text>
                        </View>
                    </View>
                </View>
            </Page>
        </Document>
    );
};

export default ReporteVentas;